import React from "react";

/**
 * Brand logo — tight-cropped PNG with transparent background.
 * `variant="dark"` inverts the colors for dark surfaces.
 */
export const Logo = ({ className = "", variant = "light", size = 64 }) => {
    const isDark = variant === "dark";
    return (
        <a
            href="#home"
            data-testid="brand-logo"
            aria-label="Design Desire LLP — home"
            className={`inline-flex items-center select-none ${className}`}
        >
            <img
                src="/logo.png"
                alt="Design Desire LLP"
                style={{
                    height: size,
                    width: "auto",
                    filter: isDark ? "invert(1) hue-rotate(180deg)" : "none",
                    display: "block",
                }}
            />
        </a>
    );
};
